let auth0Client: any | null = null

export function setAuth0Client(client: any) {
  auth0Client = client
}

export function getAuth0Client(): any | null {
  return auth0Client
}


